import { jsx as t } from "react/jsx-runtime";
import { c as r } from "../background-bUl5ds8G.js";
import { c as l } from "../clsx-OuTLNxxd.js";
const _ = "Tag-module_tag__LljoB",
  u = "Tag-module_large__z1XA9",
  i = "Tag-module_success__qALDl",
  m = "Tag-module_warning__4ovIb",
  d = "Tag-module_negative__VsBjb",
  s = {
    tag: _,
    large: u,
    success: i,
    warning: m,
    negative: d
  },
  f = _ref => {
    let {
      children: e,
      backgroundColor: g,
      size: c = "standard",
      variant: a = "default",
      className: n
    } = _ref;
    const o = r(g);
    return /* @__PURE__ */t("div", {
      className: l(s.tag, o, n, {
        [s.large]: c == "large",
        [s.success]: a == "success",
        [s.warning]: a == "warning",
        [s.negative]: a == "negative"
      }),
      children: e
    });
  };
export { f as Tag };